import React, { useEffect, useState } from "react";
import { SDK_INIT_OPTIONS } from "../constants/sdk";
import { initializeSDK } from "../utils/sdkUtils";
import { SDKContext } from "./SDKContext";

export const SDKProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [sdkReady, setSdkReady] = useState(false);

  useEffect(() => {
    initializeSDK("backlotclub", SDK_INIT_OPTIONS,
      (status) => {
      },
      (authState) => {
      }
    ).then(() => setSdkReady(true)).catch(console.error);
  }, []);

  return (
    <SDKContext.Provider value={{ sdkReady }}>
      {children}
    </SDKContext.Provider>
  );
};
